export default __webpack_public_path__ + "static/media/020_start.8b1b3d4c.mp3";